import { axiosInstance } from '../../../api';

const base = 'api/attendance/web';

export const attendanceWebApi = {
  status: () => axiosInstance.get(`${base}/current-status/`).then((r) => r.data),
  clockIn: (requestId) =>
    axiosInstance.post(`${base}/clock-in/`, { request_id: requestId }).then((r) => r.data),
  clockOut: (requestId) =>
    axiosInstance.post(`${base}/clock-out/`, { request_id: requestId }).then((r) => r.data),
  breakStart: (requestId) =>
    axiosInstance.post(`${base}/break-start/`, { request_id: requestId }).then((r) => r.data),
  breakEnd: (requestId) =>
    axiosInstance.post(`${base}/break-end/`, { request_id: requestId }).then((r) => r.data),
  history: (params) =>
    axiosInstance.get(`${base}/history/`, { params }).then((r) => r.data),
  regularizations: (params) =>
    axiosInstance.get(`${base}/regularizations/`, { params }).then((r) => r.data),
  createRegularization: (data) =>
    axiosInstance.post(`${base}/regularizations/`, data).then((r) => r.data),
  monitor: (params) =>
    axiosInstance.get(`${base}/monitor/`, { params }).then((r) => r.data),
  regularizationReviews: (params) =>
    axiosInstance.get(`${base}/regularizations/review/`, { params }).then((r) => r.data),
  reviewRegularization: (id, data) =>
    axiosInstance.post(`${base}/regularizations/${id}/review/`, data).then((r) => r.data),
};
